import { LocationReports } from '../components/LocationReports/LocationReports';

export const ReportsPage = () => {
  return <LocationReports />;
};
